<template>
  <b-modal title="Критерии оценки" ref="setMarksModal"
    id="setMarksModal" header-bg-variant="primary" header-text-variant="light"
    ok-title="Сохранить" cancel-title="Отмена" ok-variant="primary"
    cancel-variant="outline-primary"
  >
    <div class="p-2">
      <strong>Количество ошибок</strong>
      <b-input-group prepend="5" class="mb-2">
        <b-form-input v-model="errors[5]" type="number" min="0" @input="validateMarks" />
        <b-form-invalid-feedback :force-show="Boolean(invalidErrors[5])">
          {{ invalidErrors[5] }}
        </b-form-invalid-feedback>
      </b-input-group>
      <b-input-group prepend="4" class="mb-2">
        <b-form-input v-model="errors[4]" type="number" min="1" @input="validateMarks" />
        <b-form-invalid-feedback :force-show="Boolean(invalidErrors[4])">
          {{ invalidErrors[4] }}
        </b-form-invalid-feedback>
      </b-input-group>
      <b-input-group prepend="3" class="mb-2">
        <b-form-input v-model="errors[3]" type="number" min="2" @input="validateMarks" />
        <b-form-invalid-feedback :force-show="Boolean(invalidErrors[3])">
          {{ invalidErrors[3] }}
        </b-form-invalid-feedback>
      </b-input-group>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'SetMarksModal',
  data() {
    return {
      errors: {
        5: undefined,
        4: undefined,
        3: undefined
      },
      invalidErrors: {
      }
    }
  },
  mounted() {
    this.validateMarks()
  },
  methods: {
    validateMarks() {
      this.invalidErrors = {}
      if (this.errors[4] <= this.errors[5]) {
        this.invalidErrors[4] = 'Значение должно быть больше, чем у 5'
      }
      if (this.errors[3] <= this.errors[4]) {
        this.invalidErrors[3] = 'Значение должно быть больше, чем у 4'
      }
      Object.keys(this.errors).forEach((key) => {
        if (this.errors[key] === undefined || this.errors[key] === '') {
          this.invalidErrors[key] = 'Значение не задано'
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
